import React from "react";
import Layout from 'Layout'
import { Form, Input, Select, Switch, Button, Card, Row, Col } from "antd";

const { Option } = Select;

const PackageForm: React.FC = () => {
  const [form] = Form.useForm();

  const onFinish = (values: any) => {
    console.log("Form data:", values);
  };

  return (
    <Layout>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        style={{ maxWidth: "100%", color: "#6e6b7b" }}
      >
        <Row gutter={16} className="form-ctrl-38">
          {/* Cột trái */}
          <Col xs={24} md={18}>
            <Card title="Thông tin đặt hàng" bordered={false}>
              {/* Hàng 1: 2 field */}
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item label="Tên" name="name">
                    <Input style={{ height: 38 }} placeholder="Nhập tên" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item label="Slug" name="slug">
                    <Input style={{ height: 38 }} placeholder="Slug tự động" />
                  </Form.Item>
                </Col>
              </Row>

              {/* Hàng 2: 3 field */}
              <Row gutter={16}>
                <Col xs={24} md={8}>
                  <Form.Item label="Giá" name="price">
                    <Input style={{ height: 38 }} addonAfter="VNĐ" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Hoa hồng" name="commission">
                    <Input style={{ height: 38 }} addonAfter="%" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Thời hạn" name="duration">
                    <Select style={{ height: 38 }} placeholder="Chọn thời hạn">
                      <Option value="1month">Một tháng</Option>
                      <Option value="3month">Ba tháng</Option>
                      <Option value="6month">Sáu tháng</Option>
                      <Option value="1year">Một năm</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              {/* Hàng 3: 3 field */}
              <Row gutter={16}>
                <Col xs={24} md={8}>
                  <Form.Item
                    label="Không giới hạn sử dụng"
                    name="unlimited"
                    valuePropName="checked"
                  >
                    <Switch />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Số lần sử dụng" name="usageLimit">
                    <Input style={{ height: 38 }} placeholder="Nhập số lần" />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Số user" name="userLimit">
                    <Input style={{ height: 38 }} placeholder="Nhập số user" />
                  </Form.Item>
                </Col>
              </Row>

              {/* Hàng 4: 3 field */}
              <Row gutter={16}>
                <Col xs={24} md={8}>
                  <Form.Item label="Price ID" name="priceId">
                    <Input style={{ height: 38 }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Product id accesstrade" name="productId">
                    <Input style={{ height: 38 }} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={8}>
                  <Form.Item label="Bundle id accesstrade" name="bundleId">
                    <Input style={{ height: 38 }} />
                  </Form.Item>
                </Col>
              </Row>
            </Card>

            <Card title="Thông tin hiển thị" bordered={false}>
              <Row gutter={16}>
                <Col xs={24} md={8}>
                  <Form.Item label="Nổi bật" name="featured" valuePropName="checked">
                    <Switch />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={24}>
                  <Form.Item label="Tên gói" name="displayName">
                    <Input style={{ height: 38 }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Giá hiển thị" name="displayPrice">
                    <Input style={{ height: 38 }} />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="Mô tả ngắn" name="shortDescription">
                    <Input style={{ height: 38 }} />
                  </Form.Item>
                </Col>
              </Row>

              <div style={{ marginTop: 8 }}>
                <Button type="primary" htmlType="submit">
                  Thêm
                </Button>
                <Button type="link">Chi tiết</Button>
              </div>
            </Card>
          </Col>

          {/* Cột phải */}
          <Col
            xs={24}
            md={6}
            style={{
              position: "sticky",
              top: 0,
              alignSelf: "flex-start",
            }}
          >
            <Card title="Trạng thái" bordered={false}>
              <Form.Item className="mb-0" name="status" valuePropName="checked">
                <Switch />
              </Form.Item>
            </Card>
          </Col>
        </Row>
      </Form>
    </Layout>
  );
};

export default PackageForm;
